(function () {
  var STORAGE_KEY = 'itu_favourites';

  function getFavourites() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return raw.map(function (item) {
        return typeof item === 'string' ? { id: item } : item;
      });
    } catch (e) {
      return [];
    }
  }

  function saveFavourites(arr) {
    var clean = arr.filter(function(f) { return f && typeof f === 'object' && f.url; });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    try { document.dispatchEvent(new CustomEvent('itu:wishlist-changed')); } catch (e) {}
  }

  function isFavourited(id) {
    return getFavourites().some(function (f) { return String(f.id) === String(id); });
  }

  function toggleFavourite(btn) {
    if (!window.ITU_LOGGED_IN) {
      showToast('Please log in to save to your Wishlist');
      setTimeout(function () {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      }, 1400);
      return false;
    }
    var id = String(btn.dataset.productId);
    var favs = getFavourites();
    var idx = favs.findIndex(function (f) { return String(f.id) === id; });
    if (idx === -1) {
      favs.push({
        id: id,
        title: btn.dataset.productTitle || '',
        url: btn.dataset.productUrl || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || ''
      });
      saveFavourites(favs);
      return true;
    } else {
      favs.splice(idx, 1);
      saveFavourites(favs);
      return false;
    }
  }

  function updateWishlistBtn(btn, active) {
    var outline = btn.querySelector('.favourite-btn__icon--outline');
    var filled  = btn.querySelector('.favourite-btn__icon--filled');
    var label   = btn.querySelector('.favourite-btn__label');
    if (active) {
      if (outline) outline.style.display = 'none';
      if (filled)  filled.style.display  = '';
      if (label)   label.textContent = 'Added to Wishlist';
      btn.setAttribute('aria-label', 'Added to Wishlist');
    } else {
      if (outline) outline.style.display = '';
      if (filled)  filled.style.display  = 'none';
      if (label)   label.textContent = 'Add to Wishlist';
      btn.setAttribute('aria-label', 'Add to Wishlist');
    }
  }

  function showToast(message) {
    var toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.style.cssText = [
        'position:fixed',
        'top:1.6rem',
        'right:1.6rem',
        'z-index:9999',
        'background:#000',
        'color:#fff',
        'padding:1.2rem 2rem',
        'font-size:1.3rem',
        'font-family:inherit',
        'border-radius:0.4rem',
        'opacity:0',
        'transition:opacity 0.25s ease',
        'pointer-events:none'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.style.opacity = '0';
    }, 2500);
  }

  function initButtons() {
    document.querySelectorAll('.favourite-btn--wishlist').forEach(function (btn) {
      var active = isFavourited(btn.dataset.productId);
      updateWishlistBtn(btn, active);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggleFavourite(btn);
        updateWishlistBtn(btn, added);
        showToast(added ? 'Product added to Wishlist' : 'Item was removed from Wishlist');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }
})();
